import React from 'react'

const AllOrderPeykTable = () => {
  return (
    <div>AllOrderPeykTable</div>
  )
}

export default AllOrderPeykTable